type DecimalInput = string | number

function decimalInputText(value: DecimalInput) {
  return typeof value === "number" ? String(value) : value
}

export function decimalText(value: DecimalInput) {
  const [whole = "0", fraction = ""] = decimalInputText(value).trim().replace(/^\+/, "").split(".")
  const sign = whole.startsWith("-") ? "-" : ""
  const digits = whole.replace("-", "").replace(/^0+(?=\d)/, "") || "0"
  const trimmedFraction = fraction.replace(/0+$/, "")
  return sign + digits + (trimmedFraction ? "." + trimmedFraction : "")
}

export function signedAmount(value: DecimalInput) {
  const normalized = decimalText(value)
  const negative = normalized.startsWith("-")
  return {
    negative,
    absolute: negative ? normalized.slice(1) : normalized,
  }
}

export function formatAmount(value: DecimalInput, symbol: string) {
  const amount = signedAmount(value)
  return (amount.negative ? "−" : "") + symbol + amount.absolute
}
